import Vue from 'vue';
import Component from 'vue-class-component';

@Component
class EdPortalGradesComponent extends Vue {}

export default Vue.component('ed-portal-grades-component', EdPortalGradesComponent);
